import React from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {
  featuresSetupUpdateFeature,
} from "./featuresActions";
import {getFeatureEditPermission, getFilteredFeatures} from "./featuresFunctions";
import Select5 from "../Generic/Select5";
import {toggleArrayValue} from "../FeatureCreator/FeaturesFilters/filtersFunctions";


const FeaturesSetupTopPanelCurrencySelect = (props) => {

  const {featuresListReceived, selectedFeatures, allFilterGroups, canEdit, featuresSetupUpdateFeature, intl} = props;

  const currencyFG = allFilterGroups.find(fg => fg.name === "Currency");
  if (!currencyFG) {
    return null
  }

  const onItemClick = (selectOption) => {
    if (!canEdit) {
      return false
    }
    selectedFeatures.forEach(feature => {
      let newFabFilters = [...(feature.fabFilterValueIds || [])];
      currencyFG.values.forEach(fValue => {
        if (fValue.id === selectOption.value) {
          if (!newFabFilters.includes(fValue.id)) { // turn on current currency, if it wasn't assigned
            newFabFilters = toggleArrayValue(newFabFilters, fValue.id);
          }
        } else if (newFabFilters.includes(fValue.id)) {
          newFabFilters = toggleArrayValue(newFabFilters, fValue.id); // remove another currency
        }
      });
      console.log("newFabFilters", currencyFG.values, newFabFilters);
      featuresSetupUpdateFeature(feature, 'fabFilterValueIds', newFabFilters);
    })
  }

  const selectItems = currencyFG.values.map(option => ({
    value: option.id,
    label: option.displayText
  }));

  const selectedItem = featuresListReceived && selectedFeatures.length ? selectItems.find(item => {
    return selectedFeatures.every(feature => {
      return (feature.fabFilterValueIds || []).includes(item.value);
    })
  }) || selectItems[0] : selectItems[0];

  return (
    <div className="en-group text-center">
      <div className="en-group__title">
        Set Currency
      </div>
      <div className="en-group__buttons">
        <Select5 selectItems={selectItems}
                 selectItemClick={onItemClick}
                 selectedItem={selectedItem}
                 placeholder={intl.formatMessage({id: "features.setup.markUpDownPopup.checkbox.currency"})}
                 className={"select5--units"
                   + (!featuresListReceived || !selectedFeatures.length ? " select--disabled opacity-50" : "")}
                 maxItems={6} />
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {canEdit} = getFeatureEditPermission(store);
  const {featuresListReceived} = store.featuresSetupState;
  const featuresList = getFilteredFeatures(store, false, true);
  const selectedFeaturesOnly = getFilteredFeatures(store, true, true);
  const selectedFeatures = selectedFeaturesOnly.length ? selectedFeaturesOnly : featuresList;
  const {allFilterGroups} = store.featuresFiltersState;

  return {
    canEdit,
    selectedFeatures,
    featuresListReceived,
    allFilterGroups,
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)
  (FeaturesSetupTopPanelCurrencySelect)
)
